module.exports = "/packs/media/images/rings-c0208aa8c53ff5aabfb074ca4378c652.png";